export default __webpack_public_path__ + "static/media/lockscreen.4402397d.jpg";